import { SxProps } from '@mui/material';

import {
  USER_APPROVE_STATUS,
  USER_QUALIFY_STATUS,
  USER_ROLE,
} from '@/config/constants';
import { useGetCurrentUserQuery } from '@/apis/extended/userApi';
import { GetApproveButton } from './GetApproveButton';
import { SeeQualifyButton } from './SeeQualifyButton';

type UserActionButtonProps = {
  sx?: SxProps;
};

const QUALIFY_ACTION_ROLES = [USER_ROLE.BUYER, USER_ROLE.USER] as const;

export const UserActionButton = ({ sx }: UserActionButtonProps) => {
  const { data: user } = useGetCurrentUserQuery();

  if (!user) return null;

  const isQualifyRole = QUALIFY_ACTION_ROLES.includes(
    user.role as (typeof QUALIFY_ACTION_ROLES)[number]
  );

  if (user.qualifyStatus !== USER_QUALIFY_STATUS.QUALIFY && isQualifyRole) {
    return <SeeQualifyButton sx={sx} />;
  }
  if (user.approveStatus !== USER_APPROVE_STATUS.APPROVED && isQualifyRole) {
    return <GetApproveButton sx={sx} />;
  }
  return null;
};
